import * as React from "react";
const SvgFiRrBugs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bugs_svg__a)">
      <path
        fill="#062147"
        d="M23 18a1 1 0 1 0 0-2h-1.45l-.595-2h.044c1.654 0 3-1.346 3-3a1 1 0 1 0-2 0 1 1 0 0 1-1 1h-.703a3.74 3.74 0 0 0-3.297-2c-1.545 0-2.947.975-3.51 2.49L12.448 16h-1.449a1 1 0 0 0 0 2h1c0 .731.158 1.426.441 2.053A3.005 3.005 0 0 0 9.999 23a1 1 0 0 0 2 0c0-.552.449-1 1-1h1.003c.836.628 1.873 1 2.997 1a4.97 4.97 0 0 0 2.997-1h1.003c.552 0 1 .449 1 1a1 1 0 0 0 2 0 3.005 3.005 0 0 0-2.441-2.947A5 5 0 0 0 21.999 18zm-9 0q0-.121.013-.239l1.373-4.638A1.73 1.73 0 0 1 17 11.999c.715 0 1.363.452 1.592 1.059l1.396 4.703q.012.118.013.239c0 1.654-1.346 3-3 3s-3-1.346-3-3zM12 8h1a1 1 0 1 0 0-2h-1.45l-.594-2H11c1.654 0 3-1.346 3-3a1 1 0 1 0-2 0c0 .552-.449 1-1 1h-.703A3.74 3.74 0 0 0 7 0C5.629 0 4.371.768 3.712 2H3c-.551 0-1-.449-1-1a1.001 1.001 0 0 0-2 0c0 1.654 1.346 3 3 3h.043l-.594 2H1a1 1 0 0 0 0 2h1c0 .731.158 1.426.441 2.053A3.005 3.005 0 0 0 0 13a1 1 0 0 0 2 0c0-.552.449-1 1-1h1.003c.836.628 1.873 1 2.997 1 2.757 0 5-2.243 5-5M7 2c.714 0 1.363.452 1.592 1.059l1.395 4.702q.012.118.013.239c0 1.654-1.346 3-3 3S4 9.654 4 8q0-.122.013-.239l1.374-4.637A1.73 1.73 0 0 1 7 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bugs_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBugs;
